<template>
  <j-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item :label="$t('任务名称')" prop="taskName">
                <a-input v-model="model.taskName" :placeholder="$t('请输入任务名称')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('任务类型')" prop="taskCategory">
                <a-select :placeholder="$t('请选择任务类型')" v-model="model.taskCategory">
                  <a-select-option :value="0">{{ $t('临时任务') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('日常任务') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('巡检计划')" prop="planId">
                <a-select show-search option-filter-prop="children" :placeholder="$t('请选择巡检计划')" v-model="model.planId" @change="planChange">
                  <a-select-option :value="item.id" v-for="item in planList">{{item.name}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item :label="$t('开始时间')" prop="taskBeganTime">
                <a-date-picker v-model="model.taskBeganTime" show-time :placeholder="$t('请选择开始时间')" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%;" :disabled-date="disabledDate" @change="onCalendarChange" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('结束时间')" prop="taskEndTime">
                <a-date-picker v-model="model.taskEndTime" show-time :placeholder="$t('请选择结束时间')" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%;" :disabled-date="disabledDate2" @change="onCalendarChange2" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import moment from 'moment';
  export default {
    // mixins: [JeecgListMixin],
    name: 'inspectionTasksModal',
    components: {},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: "/jeecg-engineering/inspection/inspectionTask/add",
          edit: "/jeecg-engineering/inspection/inspectionTask/edit",
          queryById: "/jeecg-engineering/inspection/inspectionPlan/queryById",
          list: "/jeecg-engineering/inspection/inspectionPlan/list",
        },
        planList: [],
        disabledCurrentStart: null,
        disabledCurrentEnd: null,
      }
    },
    computed: {
      validatorRules() {
        return {
          taskName: [{
            required: true,
            message: this.$t('请输入任务名称'),
            trigger: 'blur'
          }],
          taskCategory: [{
            required: true,
            message: this.$t('请选择任务类型'),
            trigger: 'change'
          }],
          planId: [{
            required: true,
            message: this.$t('请选择巡检计划'),
            trigger: 'change'
          }],
          // taskEndTime: [{
          //   required: true,
          //   message: '请选择结束时间',
          //   trigger: 'change'
          // }],
          // taskBeganTime: [{
          //   required: true,
          //   message: '请选择开始时间',
          //   trigger: 'change'
          // }],
        }
      },
    },
    methods: {
      getplanList() {
        this.planList = [];
        getAction(this.url.list,{pageSize:999,order: 'desc',column: 'createTime',source:1}).then(res => {
          if (res.success) {
            res.result.records.forEach(item => {
              if(item.planState == 0){
                this.planList.push({
                  name:item.planName,
                  id:item.id
                });
              }
            });
          }
        });
      },
      planChange(e){
        let plan = this.planList.find(p=>p.id == e);
        this.$set(this.model,'planName',plan.name);
        // getAction(this.url.queryById,{id:e}).then(res=>{
        //   if(re.success){
        //     this.planInfo = res.result;
        //   }
        // })
      },
      add() {
        this.visible = true;
        this.model = {};
        this.getplanList();
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      },
      edit(record) {
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(record));
        this.getplanList();
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
              delete this.model.createTime;
            }
            this.model.source = 1;
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.disabledCurrentStart = null
        this.disabledCurrentEnd = null
        this.close()
      },
      disabledDate(current) {
          return current > moment(this.disabledCurrentEnd) // 大于当前日期不能选
      },
      disabledDate2(current) {
          return current < moment(this.disabledCurrentStart) // 小于当前日期不能选
      },
      onCalendarChange(value, mode) {
          this.disabledCurrentStart = mode
      },
      onCalendarChange2(value, mode) {
          this.disabledCurrentEnd = mode
      },
    }
  }
</script>
